/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-bind */
import { Button, Modal, Result } from 'antd';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { CaretRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { api } from '../../../../services/api';
import { ErrorMessage } from './styles';

export function ModalStartPreAnalysis({
  isOpenModalStartPreAnalysis,
  setIsOpenModalStartPreAnalysis,
  orderToStartPreAnalysis,
}) {
  const [startCorrectionLoading, setStartCorrectionLoading] = useState(false);
  const [initCorrectionErrorMessage, setInitCorrectionErrorMessage] =
    useState('');

  const navigate = useNavigate();

  async function startPreAnalise() {
    setStartCorrectionLoading(true);
    try {
      await api.post(`/orders/start-pre-analysis/${orderToStartPreAnalysis.id}`);
      toast.success('Pré analise iniciada com sucesso');
      navigate(`/pedidos/visualizar/${orderToStartPreAnalysis.id}`);
      setStartCorrectionLoading(false);
    } catch (error) {
      toast.error('Erro ao inicar correção');
      setInitCorrectionErrorMessage(error.response.data.message);
      setStartCorrectionLoading(false);
    }
  }

  return (
    <Modal
      title="Iniciar Pré-análise"
      open={isOpenModalStartPreAnalysis}
      footer={null}
      onCancel={() => {
        setIsOpenModalStartPreAnalysis(false);
        setInitCorrectionErrorMessage('');
      }}
      width={700}
      style={{ textAlign: 'center' }}
    >
      <Result
        status="warning"
        title="Tem certeza que deseja iniciar a pré-análise?"
      />

      <div style={{ fontSize: 22 }}>
        <strong>
          {`
          Pedido: ${orderToStartPreAnalysis && orderToStartPreAnalysis.order_number
            }`}
        </strong>
      </div>

      <div style={{ textAlign: 'center', marginTop: 50 }}>
        <Button
          style={{ background: '#4AD697' }}
          icon={<CaretRightOutlined />}
          type="primary"
          color="green"
          onClick={startPreAnalise}
          loading={startCorrectionLoading}
        >
          Iniciar pré-análise
        </Button>

        <ErrorMessage>
          <span>{initCorrectionErrorMessage}</span>
        </ErrorMessage>
      </div>
    </Modal>
  );
}
